import { lazy } from "react";

const Cutomers = lazy(() => import("./Cutomers"));
const Marketing = lazy(() => import("./Marketing"));
const ContactForm = lazy(() => import("./ContactEditor2"));

const CustomRoutes = [
  {
    path: "/custmLeads/customers",
    element: <Cutomers />,
  },
  {
    path: "/custmLeads/marketing",
    element: <Marketing />,
  },
  {
    path: "/custmLeads/new",
    element: <ContactForm />,
  },
  {
    path: "/custmLeads/edit/:id",
    element: <ContactForm />,
  },
  
];

export default CustomRoutes;
